import { useState, type FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage('');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('website_alt') as string || '').trim();

    if (honeypot) {
      setStatus('success');
      setMessage('感谢订阅！');
      setEmail('');
      return;
    }

    if (!email.trim()) {
      setStatus('error');
      setMessage('请输入您的邮箱地址');
      return;
    }

    const payload = new URLSearchParams();
    payload.append('email', email);

    try {
      const res = await fetch('https://readdy.ai/api/form/d9tvl1v8l97n3eas3eh0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！我们会定期为您推送精选旅行攻略。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试';
        setStatus('error');
        setMessage(serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查您的网络连接后重试');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-accent-500">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mx-auto mb-4 rounded-full bg-white/20">
          <i className="ri-mail-send-line text-xl md:text-2xl text-white"></i>
        </div>
        <h2 className="font-heading text-xl md:text-2xl font-semibold text-white mb-2">
          订阅亚洲旅行灵感
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-6">
          每周精选亚洲旅行攻略、特价机票与酒店优惠，让旅行灵感不断
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            readOnly
            aria-hidden="true"
            className="spam-guard"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入您的邮箱地址"
            required
            className="flex-1 px-4 py-2.5 rounded-full text-sm bg-white/15 backdrop-blur-sm text-white placeholder-white/50 border border-white/20 focus:outline-none focus:border-white/40 transition-colors"
          />
          <button
            type="submit"
            className="px-6 py-2.5 bg-white text-accent-600 text-sm font-medium rounded-full hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
          >
            立即订阅
          </button>
        </form>

        {status !== 'idle' && message && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-white/90' : 'text-white/90'}`}>
            {message}
          </p>
        )}

        <p className="mt-4 text-xs text-white/50">
          订阅即表示同意我们的隐私政策，您可以随时退订
        </p>
      </div>
    </section>
  );
}